// Example values used across get-started components
export const EXAMPLE_ACTOR_ID = "alice";
export const EXAMPLE_ROLE = "viewer";
export const EXAMPLE_RESOURCE_ID = "foo";
export const EXAMPLE_ACTION = "view";
